export default [
  {
    produktlinie: "002",
    tarifNummer: 0,
    tarifBeschreibung: "Der Klassiker",
    tarifFarbe: "#e7eef2",
  },
  {
    produktlinie: "003",
    tarifNummer: 1,
    tarifBeschreibung: "Meistgewählt",
    tarifFarbe: "#9ad0b7",
  },
];
